// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

// dynamically set active navbar link
function set_nav_active() {
	document.querySelectorAll('.navbar-nav .nav-link.active').forEach((x) => {
		x.classList.remove('active');
	});

	// console.log("Setting current nav: ", document.querySelector(`.nav-link[href="${window.location.pathname}"]`));
	document.querySelector(`.nav-link[href="${window.location.pathname}"]`).classList.add('active');
}

window.addEventListener('load', () => { set_nav_active(); });
document.addEventListener('turbo:load', () => { set_nav_active(); });
